import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

function KameraDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [kamera, setKamera] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seciliResimIndex, setSeciliResimIndex] = useState(0);

  const sliderRef = useRef(null);

  // --- EFSANEVİ DOKUNMATİK KAYDIRMA (SWIPE) MOTORU ---
  const [dokunmaBaslangic, setDokunmaBaslangic] = useState(null);
  const [dokunmaBitis, setDokunmaBitis] = useState(null);
  const minKaydirmaMesafesi = 50; 

  const dokunmaBasladi = (e) => {
    setDokunmaBitis(null);
    setDokunmaBaslangic(e.targetTouches[0].clientX);
  };

  const dokunmaHareketEtti = (e) => {
    setDokunmaBitis(e.targetTouches[0].clientX);
  };

  const dokunmaBitti = () => {
    // Kamera verisi tam yüklenmediyse veya resim yoksa motoru durdur
    if (!dokunmaBaslangic || !dokunmaBitis || !kamera) return;

    // Resim listesini belirliyoruz
    const resimListesi = (kamera.resimler && kamera.resimler.length > 0) ? kamera.resimler : [kamera.resim_url];
    const toplamResim = resimListesi.length;
    
    // Tek resim varsa kaydırmaya gerek yok
    if (toplamResim <= 1) return;

    const mesafe = dokunmaBaslangic - dokunmaBitis;
    const solaKaydirildi = mesafe > minKaydirmaMesafesi;
    const sagaKaydirildi = mesafe < -minKaydirmaMesafesi;

    if (solaKaydirildi) {
      setSeciliResimIndex((onceki) => (onceki === toplamResim - 1 ? 0 : onceki + 1));
    }
    if (sagaKaydirildi) {
      setSeciliResimIndex((onceki) => (onceki === 0 ? toplamResim - 1 : onceki - 1));
    }
  };
  // ----------------------------------------------------

  useEffect(() => {
    const kameraGetir = async () => {
      try {
        const { data, error } = await supabase.from('kameralar').select('*').eq('id', id).single();
        if (error) throw error;
        setKamera(data);
        setSeciliResimIndex(0);
      } catch (error) { 
        console.error(error.message); 
      } finally { 
        setLoading(false); 
      }
    };
    kameraGetir();
  }, [id]);

  const whatsappSiparis = (kameraAdi) => {
    const telefon = "905305090631"; // Senin Kurumsal Demir Grup Numaran!
    const mesaj = `Merhaba, web sitenizdeki "${kameraAdi}" modeli hakkında fiyat ve detaylı bilgi almak istiyorum.`;
    window.open(`https://wa.me/${telefon}?text=${encodeURIComponent(mesaj)}`, '_blank');
  };

  const kaydir = (yon) => {
    if (sliderRef.current) {
      const kaydirmaMiktari = 200; 
      sliderRef.current.scrollBy({ left: yon === 'sol' ? -kaydirmaMiktari : kaydirmaMiktari, behavior: 'smooth' });
    }
  };

  if (loading) return <div className="loading-spinner" style={{paddingTop: '150px'}}>Yükleniyor...</div>;
  if (!kamera) return <div style={{paddingTop: '150px', textAlign: 'center', color: 'white'}}>Kamera bulunamadı!</div>;

  const resimListesi = (kamera.resimler && kamera.resimler.length > 0) ? kamera.resimler : [kamera.resim_url];

  return (
    <div className="kamera-detay-page-new">
      <div className="detay-ust-bar">
        <button className="geri-btn" onClick={() => navigate(-1)}><span>←</span> Geri</button>
      </div>

      <div className="detay-container-new">
        
        <div className="detay-image-new">
          
          {/* SENSÖRLERİ ANA RESME TAKTIK! */}
          <div 
            className="ana-resim-box"
            onTouchStart={dokunmaBasladi}
            onTouchMove={dokunmaHareketEtti}
            onTouchEnd={dokunmaBitti}
          >
            <img src={resimListesi[seciliResimIndex]} alt={kamera.baslik} />
          </div>
          
          <div className="thumbnails-wrapper">
            <button className="slider-btn sol" onClick={() => kaydir('sol')}>&#10094;</button>
            
            <div className="detay-thumbnails" ref={sliderRef}>
              {resimListesi.map((resimUrl, index) => (
                <div 
                  key={index} 
                  className={`thumbnail-item ${seciliResimIndex === index ? 'active' : ''}`} 
                  onClick={() => setSeciliResimIndex(index)}
                >
                  <img src={resimUrl} alt={`Thumbnail ${index + 1}`} />
                </div>
              ))}
            </div>

            <button className="slider-btn sag" onClick={() => kaydir('sag')}>&#10095;</button>
          </div>
        </div>

        <div className="detay-info-new">
          <div className="modal-header-line">Demir Grup | Güvenlik Çözümleri</div>
          <h1>{kamera.baslik}</h1>
          <p className="detay-desc-new">{kamera.aciklama}</p>
          
          <div className="detay-features-new">
            {kamera.ozellikler && kamera.ozellikler.split(',').map((ozellik, index) => (
              <div key={index} className="feature-item-new">
                <span className="feature-icon">✓</span><span>{ozellik.trim()}</span>
              </div>
            ))}
          </div>

          <button className="whatsapp-btn-large-new" onClick={() => whatsappSiparis(kamera.baslik)}>
            <span className="wa-icon">💬</span> WhatsApp'tan Fiyat Al
          </button>
          <p className="guvence-metni">🛡️ Demir Grup Güvencesiyle Kurulum ve Montaj</p>
        </div>
      </div>
    </div>
  );
}

export default KameraDetay;